export default __webpack_public_path__ + "static/blueGreen-518e3bce22584f32e8efeadf977bd49a.png";